import { FormGroup } from "reactstrap";

import DateTimePicker from "../DateTimePicker/DateTimePicker";
import { Col } from "../Grid/Grid";

const TableCalendarFilter = ({
  start,
  setStart = () => {},
  end,
  setEnd = () => {},
}) => {
  return (
    <>
      <Col size="12" sm="6" md="4" lg="3" xxl="2" className="mt-3">
        <FormGroup>
          <label className="form-label" htmlFor="type">
            از تاریخ
          </label>
          <div className="form-control-wrap">
            <DateTimePicker
              placeholder="از تاریخ را وارد نمایید"
              initValue={start}
              onChange={setStart}
              withTime
              showTimeInput
            />
          </div>
        </FormGroup>
      </Col>

      <Col size="12" sm="6" md="4" lg="3" xxl="2" className="mt-3">
        <FormGroup>
          <label className="form-label" htmlFor="type">
            تا تاریخ
          </label>
          <div className="form-control-wrap">
            <DateTimePicker
              placeholder="تا تاریخ را وارد نمایید"
              initValue={end}
              onChange={setEnd}
              withTime
              showTimeInput
            />
          </div>
        </FormGroup>
      </Col>
    </>
  );
};

export default TableCalendarFilter;
